// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/back/back.scss
// module id = 514
// module chunks = 0